import script from "./Artifact.vue?vue&type=script&setup=true&lang=js"
export * from "./Artifact.vue?vue&type=script&setup=true&lang=js"

import "./Artifact.vue?vue&type=style&index=0&id=4600a313&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4600a313"]])

export default __exports__